"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsOrderActive = exports.setTransfer = exports.setIsMarketingConsent = exports.setPublicType = exports.setSecretHint = exports.setSecretPassword = exports.setIsSecret = exports.setAdditionalQuestions = exports.setSecondCustom = exports.setSecondPaid = exports.setIsRefundAccount = exports.setSnsType = exports.setPayType = exports.setKeepingRefundPolicy = exports.setRefundPolicy = exports.setContents = exports.switchCustomDelivery = exports.setCustomDeliveryInfo = exports.setNeedDeliveryChangeWarning = exports.modifyCustom = exports.deleteCustom = exports.addCustom = exports.setDiffDeliveryInfo = exports.modifyDifferentials = exports.deleteDifferentials = exports.addDifferentials = exports.modifyConditional = exports.modifyAdditional = exports.modifyFixed = exports.setDeliveryType = exports.setProductInfo = exports.invalidateFreeFormData = exports.setProductImage = exports.deleteRoomTag = exports.addRoomTag = exports.setDeliveryStartDate = exports.setEndDate = exports.setStartDate = exports.setIsFeeFree = exports.setRoomTitle = exports.setRoomImage = exports.setRoomDeliveryRegion = exports.setRoomCreateStep = exports.getRoomData = exports.getRefundPolicy = exports.removeProduct = exports.duplicateProduct = exports.getProductsData = exports.initProduct = exports.createNewRoom = void 0;
exports.roomCreateStore = exports.setOpenPromiseEditModal = exports.setIsTicket = exports.setRegularSales = exports.modifyAdditionRequiredCheck = exports.modifyAdditionImageCheck = exports.modifyAdditionQuestion = exports.deleteAdditionQuestion = exports.addAdditionQuestion = exports.setRoomCategory = exports.setIsNewRoomOpening = void 0;
const store_1 = __importDefault(require("@/store"));
const toolkit_1 = require("@reduxjs/toolkit");
const crypto_js_1 = __importDefault(require("crypto-js"));
const moment_1 = __importDefault(require("moment"));
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const errors_1 = require("@/common/errors");
const isEdit = window.location.pathname.includes('room_edit') ||
    window.location.pathname.includes('commission-update');
const isCloneRoom = window.location.search.includes('clone');
const initialState = {
    roomCreateStep: isCloneRoom ? 'clone' : '1',
    isRoomPrepared: false,
    isEdit: isEdit,
    roomData: {
        id: 0,
        room_type: '굿즈',
        room_type_cd: 'ROOM_TYPE_00',
        delivery_region: 'KR',
        img_url: null,
        title: '',
        fee_free: false,
        tag: [],
        contents: '',
        start_date: '',
        end_date: '',
        support_delivery_date: '',
        second_deadline: false,
        deliveries: [],
        refund_policy: '',
        fonds: [],
        paytype: 'login_required',
        snstype: 'no_sns',
        is_refund_account: true,
        second_paid: false,
        second_custom: false,
        is_question: false,
        is_required: false,
        publictype: 'public',
        is_marketing_consent: true,
        transfer: false,
        isValid: false,
        follow_counts: 0,
        goal_num: 0,
        goal_type_cd: null,
        images: [],
        isConvertCredit: false,
        isDeleted: false,
        isTwitter: false,
        language_cd: '',
        leader: 0,
        leader_nick: '',
        leader_profile_img_url: '',
        like_counts: 0,
        mod_dt: '',
        order_url: null,
        payment_approval_cd: 'ROOM_PAY_APPROVAL_STATUS_03',
        product_price: 0,
        public_status_cd: '',
        rank: 0,
        receipt_arrange_date: null,
        regTime: '',
        reg_dt: '',
        room_status_cd: 'ROOM_STATUS_01',
        second_deadline_set_time: null,
        second_end_date: null,
        second_start_date: null,
        sns_type_cd: '',
        subcontractor_pay_date: null,
        summary: '',
        total_members_amount: 0,
        total_sales_amount: 0,
        total_withdrawable_amount: 0,
        twitter_leader_id: null,
        updTime: '',
        use: true,
        view_counts: 0,
        questions: [
            {
                content: '',
                is_image: false,
                is_required: false,
            },
        ],
        is_ticket: false,
        has_like: false,
        is_order_active: true,
        is_secret: false,
        secret_password: null,
        secret_hint: null,
        is_new_room_opening: true,
        original_room: null,
    },
    productData: [],
    originProductData: '',
    deliveryType: '6',
    freeDeliveries: [
        {
            delivery_type: 2,
            origin_price: 0,
            delivery_price: 0,
        },
    ],
    fixedDeliveries: [
        {
            delivery_type: 1,
            origin_price: 0,
            delivery_price: 0,
        },
    ],
    additionalDeliveries: [
        {
            delivery_type: 5,
            origin_price: 0,
            delivery_price: 0,
        },
    ],
    conditionalDeliveries: [
        {
            delivery_type: 4,
            origin_price: 0,
            delivery_price: 0,
            number: 0,
        },
    ],
    diffDeliveries: [
        {
            delivery_type: 3,
            origin_price: 0,
            delivery_price: 0,
            number: 1,
        },
        {
            delivery_type: 3,
            origin_price: 0,
            delivery_price: 0,
            number: 3,
        },
    ],
    isCustomDelivery: false,
    customDeliveries: [
        {
            delivery_type: 6,
            origin_price: 0,
            delivery_price: 0,
            name: '무료',
        },
    ],
    needDeliveryChangeWarning: true,
    delete_deliveries: [],
    delete_questions: [],
    productDataFetched: false,
    refundPolicyFetched: false,
    keepingRefundPolicy: false,
    originRefundPolicy: '',
    regularSales: false,
    openPromiseEditModal: false,
    isDemandSurvey: false,
    isCommission: false,
};
const storeName = 'roomCreate';
exports.createNewRoom = (0, toolkit_1.createAsyncThunk)(`${storeName}/createNewRoom`, ({ roomType, deliveryRegion, }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.postData)('/api/v1/store/room', {
        room_type: roomType,
        delivery_region: deliveryRegion,
    })
        .then(res => {
        if (res.status === 201)
            return res.data.result;
        // ? 생성 성공
        else
            return rejectWithValue('rejected');
    })
        .catch(() => rejectWithValue('rejected'));
}));
const initialProductData = {
    name: 'blank',
    origin_price: 0,
    price: 0,
    stock: 0,
    purchase_limit: 0,
};
const isDelivery = true;
exports.initProduct = (0, toolkit_1.createAsyncThunk)(`${storeName}/initProduct`, (roomId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.postData)(`/api/v1/store/room/${roomId}/product`, initialProductData)
        .then(res => {
        const { status: responseStatus } = res;
        if (responseStatus === 201) {
            return res.data.result;
        }
        else {
            return rejectWithValue(responseStatus);
        }
    })
        .catch(err => {
        var _a, _b, _c, _d;
        const errorCode = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.alert_type;
        const errorStatus = (_d = err.response) === null || _d === void 0 ? void 0 : _d.status;
        return rejectWithValue(errorCode || errorStatus);
    });
}));
exports.getProductsData = (0, toolkit_1.createAsyncThunk)(`${storeName}/getProductsData`, (roomId, { rejectWithValue, dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)(`/api/v1/store/room/${roomId}/product`)
        .then(res => {
        if (res.status === 200) {
            const { result: productsData } = res.data;
            if (productsData.length === 0) {
                dispatch((0, exports.initProduct)(roomId));
            }
            return productsData;
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => rejectWithValue('rejected'));
}));
exports.duplicateProduct = (0, toolkit_1.createAsyncThunk)(`${storeName}/duplicateProduct`, (arg, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { roomId, clone, setDuplicating } = arg;
    return yield (0, api_1.postData)(`/api/v1/store/room/${roomId}/product`, clone)
        .then(res => {
        if (res.status === 201) {
            return res.data.result;
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => {
        return rejectWithValue('rejected');
    })
        .finally(() => setDuplicating(false));
}));
exports.removeProduct = (0, toolkit_1.createAsyncThunk)(`${storeName}/removeProduct`, (arg, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { roomId, productId, setDeleting, productIndex } = arg;
    return yield (0, api_1.deleteData)(`/api/v1/store/room/${roomId}/product/${productId}`)
        .then(res => {
        if (res.status === 204) {
            return productIndex;
        }
        else {
            setDeleting(false);
            return rejectWithValue('rejected');
        }
    })
        .catch(() => {
        setDeleting(false);
        return rejectWithValue('rejected');
    });
}));
exports.getRefundPolicy = (0, toolkit_1.createAsyncThunk)(`${storeName}/getRefundPolicy`, () => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)('/api/v1/store/refund_policy')
        .then(res => {
        if (res.status === 200) {
            return res.data.result.refund_policy;
        }
    })
        .catch(() => { });
}));
exports.getRoomData = (0, toolkit_1.createAsyncThunk)(`${storeName}/getRoomData`, (roomId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const isCloneRoom = roomId === 'clone';
    let originRoomId = 0;
    let cloneRoomId = 0;
    if (isCloneRoom) {
        const encodedEncrypted = (0, functions_1.getSearchParam)('clone');
        const decodedEncrypted = decodeURIComponent(encodedEncrypted || '');
        const bytes = crypto_js_1.default.AES.decrypt(decodedEncrypted, process.env.CRYPTO_KEY || '');
        const decryptedString = bytes.toString(crypto_js_1.default.enc.Utf8);
        const decryptedObject = JSON.parse(decryptedString);
        originRoomId = decryptedObject.origin_id;
        cloneRoomId = decryptedObject.clone_id;
    }
    return yield (0, api_1.getData)(`/api/v1/store/room/${isCloneRoom ? originRoomId : roomId}`)
        .then((res) => __awaiter(void 0, void 0, void 0, function* () {
        if (isCloneRoom) {
            let clonedImage = null;
            const { img_url, thumbnail } = res.data.result;
            if (img_url) {
                const imageBlob = yield fetch(img_url)
                    .then(r => r.blob())
                    .then(blobFile => new File([blobFile], `image_copy_${cloneRoomId}.webp`, { type: 'image/webp' }));
                const thumbnailBlob = yield fetch(thumbnail)
                    .then(r => r.blob())
                    .then(blobFile => new File([blobFile], `thumbnail_copy_${cloneRoomId}.webp`, { type: 'image/webp' }));
                const formData = new FormData();
                formData.append('image', imageBlob);
                formData.append('thumbnail', thumbnailBlob);
                clonedImage = yield (0, api_1.postFormData)(`/api/v1/room/${cloneRoomId}/image`, formData)
                    .then(res => res.data.result.image)
                    .catch(() => 'imageCloneFailed');
            }
            if (clonedImage === 'imageCloneFailed') {
                return rejectWithValue(clonedImage);
            }
            return Object.assign(Object.assign({}, res.data.result), { original_room: originRoomId, id: cloneRoomId, img_url: clonedImage ? clonedImage : null });
        }
        else
            return res.data.result;
    }))
        .catch(err => rejectWithValue(err));
}));
const roomCreateSlice = (0, toolkit_1.createSlice)({
    name: storeName,
    initialState,
    reducers: {
        setRoomCreateStep: (state, { payload }) => {
            state.roomCreateStep = payload;
        },
        setRoomDeliveryRegion: (state, { payload }) => {
            state.roomData.delivery_region = payload;
        },
        setRoomImage: (state, { payload }) => {
            state.roomData.img_url = payload;
        },
        setRoomTitle: (state, { payload }) => {
            state.roomData.title = payload;
        },
        setIsFeeFree: (state, { payload: isFeeFree }) => {
            state.roomData.fee_free = isFeeFree;
            // 배송비 수수료 전환
            const newDeliveries = state.roomData.deliveries;
            const newFixedDeliveries = state.fixedDeliveries;
            const newAdditionalDeliveries = state.additionalDeliveries;
            const newConditionDeliveries = state.conditionalDeliveries;
            const newDiffDeliveries = state.diffDeliveries;
            const newCustomDeliveries = state.customDeliveries;
            const changeDeliveryPrice = (delivery) => (delivery.delivery_price = (0, string_utils_1.feePrice)(delivery.origin_price, isFeeFree, isDelivery));
            newDeliveries.forEach(changeDeliveryPrice);
            state.roomData.deliveries = newDeliveries;
            newFixedDeliveries.forEach(changeDeliveryPrice);
            state.fixedDeliveries = newFixedDeliveries;
            newAdditionalDeliveries.forEach(changeDeliveryPrice);
            state.additionalDeliveries = newAdditionalDeliveries;
            newConditionDeliveries.forEach(changeDeliveryPrice);
            state.conditionalDeliveries = newConditionDeliveries;
            newDiffDeliveries.forEach(changeDeliveryPrice);
            state.diffDeliveries = newDiffDeliveries;
            newCustomDeliveries.forEach(changeDeliveryPrice);
            state.customDeliveries = newCustomDeliveries;
            // 작품가격 수수료 전환
            const newProductData = state.productData;
            newProductData.forEach(product => (product.price = (0, string_utils_1.feePrice)(product.origin_price, isFeeFree)));
            state.productData = newProductData;
        },
        setStartDate: (state, { payload }) => {
            state.roomData.start_date = payload;
        },
        setEndDate: (state, { payload }) => {
            state.roomData.end_date = payload;
        },
        setDeliveryStartDate: (state, { payload }) => {
            state.roomData.support_delivery_date = payload;
        },
        addRoomTag: (state, { payload }) => {
            if (!state.roomData.tag.includes(payload)) {
                state.roomData.tag.push(payload);
            }
        },
        deleteRoomTag: (state, { payload }) => {
            state.roomData.tag.splice(payload, 1);
        },
        setProductImage: (state, { payload }) => {
            const { productId, images } = payload;
            const targetIndex = state.productData.findIndex(item => item.id === productId);
            state.productData[targetIndex].images = images;
        },
        invalidateFreeFormData: (state, { payload }) => {
            state.productData[payload].isFreeFormData = false;
        },
        setProductInfo: (state, { payload }) => {
            const { productIndex, field, value } = payload;
            const targetProduct = state.productData[productIndex];
            if (field === 'origin_price') {
                const isFeeFree = state.roomData.fee_free;
                state.productData[productIndex] = Object.assign(Object.assign({}, targetProduct), { origin_price: value, price: (0, string_utils_1.feePrice)(value, isFeeFree) });
            }
            else {
                state.productData[productIndex] = Object.assign(Object.assign({}, targetProduct), { [field]: value });
            }
        },
        setDeliveryType: (state, { payload }) => {
            state.deliveryType = payload;
        },
        //! 고정
        modifyFixed: (state, { payload }) => {
            const { origin_price } = payload;
            const delivery_price = (0, string_utils_1.feePrice)(origin_price, state.roomData.fee_free, isDelivery);
            state.fixedDeliveries[0].origin_price = origin_price;
            state.fixedDeliveries[0].delivery_price = delivery_price;
        },
        //! 도서산간
        modifyAdditional: (state, { payload }) => {
            const { origin_price } = payload;
            const delivery_price = (0, string_utils_1.feePrice)(origin_price, state.roomData.fee_free, isDelivery);
            state.additionalDeliveries[0].origin_price = origin_price;
            state.additionalDeliveries[0].delivery_price = delivery_price;
        },
        //! 조건부 무료배송
        modifyConditional: (state, { payload }) => {
            const { origin_price, number } = payload;
            const delivery_price = (0, string_utils_1.feePrice)(origin_price, state.roomData.fee_free, isDelivery);
            if (typeof number === 'number') {
                state.conditionalDeliveries[0].number = number;
            }
            if (typeof origin_price === 'number') {
                state.conditionalDeliveries[0].origin_price = origin_price;
                state.conditionalDeliveries[0].delivery_price = delivery_price;
            }
        },
        addDifferentials: state => {
            const diffArrLength = state.diffDeliveries.length;
            const nextDiff = diffArrLength > 0 ? state.diffDeliveries[diffArrLength - 1].number + 1 : 1;
            state.diffDeliveries.push({
                delivery_type: 3,
                origin_price: 0,
                delivery_price: 0,
                number: nextDiff,
            });
        },
        deleteDifferentials: (state, { payload }) => {
            var _a;
            const deletedDeliveryId = ((_a = state.diffDeliveries.splice(payload, 1)[0]) === null || _a === void 0 ? void 0 : _a.id) || 0;
            if (deletedDeliveryId)
                state.delete_deliveries.push(deletedDeliveryId);
        },
        modifyDifferentials: (state, { payload }) => {
            const { quantityInput, index } = payload;
            state.diffDeliveries[index].number = quantityInput;
        },
        setDiffDeliveryInfo: (state, { payload }) => {
            const { origin_price, index } = payload;
            const delivery_price = (0, string_utils_1.feePrice)(origin_price, state.roomData.fee_free, isDelivery);
            state.diffDeliveries[index].origin_price = origin_price;
            state.diffDeliveries[index].delivery_price = delivery_price;
        },
        addCustom: state => {
            state.customDeliveries.push({
                delivery_type: 6,
                origin_price: 0,
                delivery_price: 0,
                name: '',
            });
        },
        deleteCustom: (state, { payload }) => {
            var _a;
            const deletedDeliveryId = ((_a = state.customDeliveries.splice(payload, 1)[0]) === null || _a === void 0 ? void 0 : _a.id) || 0;
            if (deletedDeliveryId)
                state.delete_deliveries.push(deletedDeliveryId);
        },
        modifyCustom: (state, { payload }) => {
            const { name, index } = payload;
            state.customDeliveries[index].name = name;
        },
        setNeedDeliveryChangeWarning: state => {
            state.needDeliveryChangeWarning = false;
        },
        setCustomDeliveryInfo: (state, { payload }) => {
            const { origin_price, index } = payload;
            const delivery_price = (0, string_utils_1.feePrice)(origin_price, state.roomData.fee_free, isDelivery);
            state.customDeliveries[index].origin_price = origin_price;
            state.customDeliveries[index].delivery_price = delivery_price;
        },
        //? 티켓 <-> 일반 구매자 맞춤배송
        switchCustomDelivery: state => {
            const isChange = state.customDeliveries[0].name == '무료' || state.customDeliveries[0].name == '현장수령';
            if (!state.isEdit && state.customDeliveries.length == 1 && isChange) {
                const tempName = state.roomData.is_ticket ? '현장수령' : '무료';
                state.customDeliveries[0].name = tempName;
            }
        },
        setContents: (state, { payload }) => {
            state.roomData.contents = payload;
        },
        setRefundPolicy: (state, { payload }) => {
            state.roomData.refund_policy = payload;
        },
        setKeepingRefundPolicy: (state, { payload }) => {
            state.keepingRefundPolicy = payload;
        },
        setPayType: (state, { payload }) => {
            state.roomData.paytype = payload;
        },
        setSnsType: (state, { payload }) => {
            state.roomData.snstype = payload;
        },
        setIsRefundAccount: (state, { payload }) => {
            state.roomData.is_refund_account = payload;
        },
        setSecondPaid: (state, { payload }) => {
            state.roomData.second_paid = payload;
        },
        setSecondCustom: (state, { payload }) => {
            state.roomData.second_custom = payload;
        },
        setAdditionalQuestions: (state, { payload }) => {
            state.roomData.is_question = payload;
        },
        setIsSecret: (state, { payload }) => {
            state.roomData.is_secret = payload;
        },
        setSecretPassword: (state, { payload }) => {
            state.roomData.secret_password = payload;
        },
        setSecretHint: (state, { payload }) => {
            state.roomData.secret_hint = payload;
        },
        setPublicType: (state, { payload }) => {
            state.roomData.publictype = payload;
        },
        setIsMarketingConsent: (state, { payload }) => {
            state.roomData.is_marketing_consent = payload;
        },
        setTransfer: (state, { payload }) => {
            state.roomData.transfer = payload;
        },
        setIsOrderActive: (state, { payload }) => {
            state.roomData.is_order_active = payload;
        },
        setIsNewRoomOpening: (state, { payload }) => {
            state.roomData.is_new_room_opening = payload;
        },
        setRoomCategory: (state, { payload }) => {
            state.roomData.category = payload;
        },
        addAdditionQuestion: state => {
            let required = false;
            if (state.roomData.is_required == undefined) {
                state.roomData.is_required = false;
            }
            required = state.roomData.is_required;
            state.roomData.questions.push({
                content: '',
                is_required: required,
                is_image: false,
            });
        },
        deleteAdditionQuestion: (state, { payload }) => {
            var _a;
            const deleteQuestionId = ((_a = state.roomData.questions.splice(payload, 1)[0]) === null || _a === void 0 ? void 0 : _a.id) || 0;
            if (deleteQuestionId)
                state.delete_questions.push(deleteQuestionId);
        },
        modifyAdditionQuestion: (state, { payload }) => {
            const { content, index } = payload;
            state.roomData.questions[index].content = content;
        },
        modifyAdditionImageCheck: (state, { payload }) => {
            const { is_image, index } = payload;
            state.roomData.questions[index].is_image = !is_image;
        },
        modifyAdditionRequiredCheck: (state, { payload }) => {
            const { is_required, index } = payload;
            state.roomData.questions[index].is_required = !is_required;
        },
        setRegularSales: (state, { payload }) => {
            state.regularSales = payload;
            if (payload) {
                state.roomData.room_type_cd = 'ROOM_TYPE_01';
            }
            else {
                state.roomData.room_type_cd = 'ROOM_TYPE_00';
            }
        },
        setIsTicket: (state, { payload }) => {
            state.roomData.is_ticket = payload;
        },
        setOpenPromiseEditModal: (state, { payload }) => {
            state.openPromiseEditModal = payload;
        },
    },
    extraReducers: {
        [exports.createNewRoom.fulfilled.type]: (state, { payload }) => {
            state.roomData = payload;
            state.roomData.title = '';
            state.roomData.start_date = (0, moment_1.default)().format(string_utils_1.zeroSecTimeFormat);
            state.roomData.end_date = (0, moment_1.default)().add(18, 'days').format(string_utils_1.zeroSecTimeFormat);
            state.roomData.support_delivery_date = ''; // moment().add(48, 'days').format(zeroSecTimeFormat);
            state.roomData.deliveries = [];
            state.roomData.paytype = 'login_required';
            state.roomData.snstype = 'no_sns';
            state.roomData.publictype = 'public';
            state.roomData.is_refund_account = true;
            state.roomData.is_new_room_opening = true;
            state.isRoomPrepared = true;
            state.roomCreateStep = '2';
            state.roomData.questions = [
                {
                    content: '',
                    is_required: false,
                    is_image: false,
                },
            ];
            if (payload.room_type === '수요조사') {
                state.isDemandSurvey = true;
                state.roomData.fee_free = true;
            }
            if (payload.room_type === '커미션') {
                state.isCommission = true;
                state.roomData.category = {
                    id: 1014,
                    img_url: 'https://s3.ap-northeast-2.amazonaws.com/fondee-dev/room/content_img/9f05234c-d6c9-4624-88b9-5bff49bd5f41',
                    name: '커미션',
                };
                state.roomData.is_question = true;
            }
        },
        [exports.createNewRoom.rejected.type]: () => {
            alert((0, errors_1.commonErrorMsg)());
            (0, functions_1.goBackOrMain)();
        },
        [exports.initProduct.fulfilled.type]: (state, { payload }) => {
            const initialData = Object.assign(Object.assign({}, payload), { name: '', stock: '', isFreeFormData: false });
            state.productData.push(initialData);
            state.productDataFetched || (state.productDataFetched = true); // ? 미리보기 이동시 해당 컴포넌트 언마운트 됨, 다시수정으로 돌어왔을 때 중복요청 방지
        },
        [exports.initProduct.rejected.type]: (_, { payload }) => alert((0, errors_1.commonErrorMsg)(payload)),
        [exports.getProductsData.fulfilled.type]: (state, { payload }) => {
            const roomType = state.roomData.room_type;
            const isRegularForm = roomType === '굿즈' || roomType === '서포트';
            const isFeeFreeGoodsForm = state.roomData.fee_free && isRegularForm;
            // ! 무료폼(isFreeFormData): 20220728 약속폼 업데이트 이전에 있었던 유형, 추가 대응용 boolean
            payload.forEach((item) => {
                if (item.origin_price == item.price && isFeeFreeGoodsForm) {
                    item.isFreeFormData = true;
                }
                else {
                    item.isFreeFormData = false;
                }
                if (item.stock === 0)
                    item.stock = '';
            });
            state.productData = payload;
            state.originProductData = JSON.stringify(payload);
            state.productDataFetched || (state.productDataFetched = true); // ? 미리보기 이동시 해당 컴포넌트 언마운트 됨, 다시수정으로 돌어왔을 때 중복요청 방지
        },
        [exports.getProductsData.rejected.type]: () => {
            alert(`${i18next_1.default.t('앗, 인터넷 연결이 불안정해요!')} ${i18next_1.default.t('등록한 작품을 불러오기 위해 새로고침 해주세요')}:)`);
        },
        [exports.duplicateProduct.fulfilled.type]: (state, { payload }) => {
            state.productData.push(Object.assign(Object.assign({}, payload), { stock: payload.stock || '', isFreeFormData: false }));
        },
        [exports.duplicateProduct.rejected.type]: () => {
            alert((0, errors_1.commonErrorMsg)());
        },
        [exports.removeProduct.fulfilled.type]: (state, { payload }) => {
            state.productData.splice(payload, 1);
        },
        [exports.removeProduct.rejected.type]: () => alert((0, errors_1.commonErrorMsg)()),
        [exports.getRefundPolicy.fulfilled.type]: (state, { payload }) => {
            if (payload) {
                state.roomData.refund_policy = payload;
                state.keepingRefundPolicy = true;
                state.originRefundPolicy = payload;
            }
            state.refundPolicyFetched = true;
        },
        [exports.getRoomData.fulfilled.type]: (state, { payload }) => {
            var _a, _b;
            state.roomData = payload;
            state.roomCreateStep = '2';
            // ? 수정시 날짜 현지화 logic
            state.roomData.start_date = (0, string_utils_1.changeKSTToLocalTime)(payload.start_date);
            state.roomData.end_date = (0, string_utils_1.changeKSTToLocalTime)(payload.end_date);
            state.roomData.support_delivery_date = (0, string_utils_1.changeKSTToLocalTime)(payload.support_delivery_date);
            //! 임시저장 때 초기화 해주기 위해
            (state.freeDeliveries = [
                {
                    delivery_type: 2,
                    origin_price: 0,
                    delivery_price: 0,
                },
            ]),
                (state.fixedDeliveries = [
                    {
                        delivery_type: 1,
                        origin_price: 0,
                        delivery_price: 0,
                    },
                ]),
                (state.additionalDeliveries = [
                    {
                        delivery_type: 5,
                        origin_price: 0,
                        delivery_price: 0,
                    },
                ]),
                (state.conditionalDeliveries = [
                    {
                        delivery_type: 4,
                        origin_price: 0,
                        delivery_price: 0,
                        number: 0,
                    },
                ]),
                (state.diffDeliveries = [
                    {
                        delivery_type: 3,
                        origin_price: 0,
                        delivery_price: 0,
                        number: 1,
                    },
                    {
                        delivery_type: 3,
                        origin_price: 0,
                        delivery_price: 0,
                        number: 3,
                    },
                ]),
                (state.customDeliveries = [
                    {
                        delivery_type: 6,
                        origin_price: 0,
                        delivery_price: 0,
                        name: '무료',
                    },
                ]);
            // ? 수정시 배송비 기본값 제공 logic (START)
            // ! delivery_option_cd: 'DELIVERY_TYPE_01' | 'DELIVERY_TYPE_00' | 'DELIVERY_TYPE_03' | 'DELIVERY_TYPE_02' | 'DELIVERY_TYPE_04' | 'DELIVERY_TYPE_05'
            //                                무료       |        고정         |        조건부        |     구매개수별 차등    |      도서산간추가     |    구매자 맞춤 배송
            // ? delivery_type(number):        2        |         1          |          4         |          3         |          5         |         6
            let freeArr = [];
            let fixedArr = [];
            let additionalArr = [];
            let conditionalArr = [];
            let diffDeliveryArr = [];
            let customDeliveryArr = [];
            payload.deliveries.forEach((item) => {
                const { id, origin_price, price: delivery_price, condition: number, delivery_option_cd, name, order_count, } = item;
                switch (delivery_option_cd) {
                    case 'DELIVERY_TYPE_01':
                        state.deliveryType = '2';
                        const freeDeliveryDataObj = {
                            delivery_type: 2,
                            origin_price,
                            delivery_price,
                        };
                        if (!isCloneRoom) {
                            Object.assign(freeDeliveryDataObj, { id });
                        }
                        freeArr.push(freeDeliveryDataObj);
                        break;
                    case 'DELIVERY_TYPE_00':
                        state.deliveryType = '1';
                        const fixedDeliveryDataObj = {
                            delivery_type: 1,
                            origin_price,
                            delivery_price,
                        };
                        if (!isCloneRoom) {
                            Object.assign(fixedDeliveryDataObj, { id });
                        }
                        fixedArr.push(fixedDeliveryDataObj);
                        break;
                    case 'DELIVERY_TYPE_03':
                        state.deliveryType = '4';
                        const conditionDeliveryDataObj = {
                            delivery_type: 4,
                            origin_price,
                            delivery_price,
                            number,
                        };
                        if (!isCloneRoom) {
                            Object.assign(conditionDeliveryDataObj, { id });
                        }
                        conditionalArr.push(conditionDeliveryDataObj);
                        break;
                    case 'DELIVERY_TYPE_02':
                        if (state.deliveryType !== '3')
                            state.deliveryType = '3';
                        const diffDeliveryDataObj = {
                            delivery_type: 3,
                            origin_price,
                            delivery_price,
                            number,
                        };
                        if (!isCloneRoom) {
                            Object.assign(diffDeliveryDataObj, { id });
                        }
                        diffDeliveryArr.push(diffDeliveryDataObj);
                        break;
                    case 'DELIVERY_TYPE_04':
                        const additionalDataObj = {
                            delivery_type: 5,
                            origin_price,
                            delivery_price,
                        };
                        if (!isCloneRoom) {
                            Object.assign(additionalDataObj, { id });
                        }
                        additionalArr.push(additionalDataObj);
                        break;
                    case 'DELIVERY_TYPE_05':
                        if (state.deliveryType !== '6')
                            state.deliveryType = '6';
                        const customDataObj = {
                            delivery_type: 6,
                            origin_price,
                            delivery_price,
                            name,
                        };
                        if (!isCloneRoom) {
                            Object.assign(customDataObj, { id, order_count });
                        }
                        customDeliveryArr.push(customDataObj);
                        break;
                }
            });
            if (!!additionalArr.length)
                state.additionalDeliveries = additionalArr;
            if (!!freeArr.length)
                state.freeDeliveries = freeArr;
            if (!!fixedArr.length)
                state.fixedDeliveries = fixedArr;
            if (!!conditionalArr.length)
                state.conditionalDeliveries = conditionalArr;
            if (!!diffDeliveryArr.length)
                state.diffDeliveries = diffDeliveryArr;
            if (!!customDeliveryArr.length)
                state.customDeliveries = customDeliveryArr;
            let deliveryArr = [];
            // '2' | '1' | '4' | '3' | '6'; // ! 무료 | 고정 | 조건부 | 구매개수별 차등 배송 | 구매자 맞춤 배송
            switch (state.deliveryType) {
                case '2':
                    deliveryArr = [...freeArr];
                    break;
                case '1':
                    deliveryArr = [...fixedArr];
                    break;
                case '4':
                    deliveryArr = [...conditionalArr];
                    break;
                case '3':
                    deliveryArr = [...diffDeliveryArr];
                    break;
                case '6':
                    deliveryArr = [...customDeliveryArr];
                    break;
            }
            // ? deliveryArr 순차적 sorting
            state.roomData.deliveries = deliveryArr.sort((a, b) => {
                if (a.delivery_type && b.delivery_type) {
                    if (a.delivery_type - b.delivery_type > 0) {
                        return 1;
                    }
                    else if (a.delivery_type - b.delivery_type === 0) {
                        if (a.number && b.number) {
                            return a.number - b.number;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return -1;
                    }
                }
                else {
                    return -1;
                }
            });
            const isCustom = Boolean(customDeliveryArr.length);
            if (isCustom) {
                state.isCustomDelivery = true;
            }
            // ? 수정시 배송비 기본값 제공 logic (END)
            // ? 수정시 상시판매 기본값 제공
            if (state.roomData.room_type_cd === 'ROOM_TYPE_01') {
                state.regularSales = true;
            }
            else {
                state.regularSales = false;
            }
            state.roomData.contents = (0, functions_1.getCdnUrl)(payload.contents);
            // ? questions 빈값일 때 기본값 제공
            if (!state.roomData.questions.length) {
                state.roomData.questions.push({
                    content: '',
                    is_required: false,
                    is_image: false,
                });
            }
            else if (isCloneRoom) {
                let questionsArr = [];
                payload.questions.forEach((question) => {
                    const { content, is_required, is_image } = question;
                    questionsArr.push({ content, is_required, is_image });
                });
                state.roomData.questions = questionsArr;
            }
            // ? 수정시 "누구나 구매할 수 있나요?" 기본값 제공 logic
            switch (payload.payment_approval_cd) {
                case 'ROOM_PAY_APPROVAL_STATUS_00':
                    state.roomData.paytype = 'parental_consent';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_01':
                    state.roomData.paytype = 'certified_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_02':
                    state.roomData.paytype = 'adult_only';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_03':
                    state.roomData.paytype = 'login_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_04':
                    state.roomData.paytype = 'under_14';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_05':
                    state.roomData.paytype = 'adult_plus';
                    break;
            }
            // ? 수정시 구매자 SNS계정 수집 기본값 제공 logic
            switch (payload.sns_type_cd) {
                case 'ROOM_CUSTOMER_SNS_TYPE_00':
                    state.roomData.snstype = 'no_sns';
                    break;
                case 'ROOM_CUSTOMER_SNS_TYPE_01':
                    state.roomData.snstype = 'twitter';
                    break;
                case 'ROOM_CUSTOMER_SNS_TYPE_02':
                    state.roomData.snstype = 'instagram';
                    break;
                case 'ROOM_CUSTOMER_SNS_TYPE_03':
                    state.roomData.snstype = 'facebook';
                    break;
                case 'ROOM_CUSTOMER_SNS_TYPE_04':
                    state.roomData.snstype = 'qq';
                    break;
            }
            // ? 수정시 기타설정 > 메인공개/검색허용 기본값 제공 logic
            state.roomData.publictype =
                payload.public_status_cd === 'PUBLIC_STATUS_00' ? 'public' : 'private';
            // ? 수정시 fonds -> category 로 전환
            state.roomData.category = (_a = payload.fonds[0]) === null || _a === void 0 ? void 0 : _a.fond;
            if (payload.room_type === '수요조사') {
                state.isDemandSurvey = true;
                state.roomData.fee_free = true;
            }
            if (payload.room_type === '커미션') {
                state.isCommission = true;
            }
            state.roomData.is_new_room_opening = (_b = payload.is_new_room_opening) !== null && _b !== void 0 ? _b : true;
            state.isRoomPrepared = true;
        },
        [exports.getRoomData.rejected.type]: (_, { payload }) => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = payload.response) === null || _a === void 0 ? void 0 : _a.status;
            if (errorStatus === 403)
                (0, functions_1.replaceToMain)();
            else {
                if (payload === 'imageCloneFailed')
                    alert((0, errors_1.commonErrorMsg)() + `(${payload})`);
                else {
                    const errorDetail = (_d = (_c = (_b = payload.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.detail;
                    alert(errorDetail || (0, errors_1.commonErrorMsg)(errorStatus));
                }
                (0, functions_1.goBackOrMain)();
            }
        },
    },
});
_a = roomCreateSlice.actions, exports.setRoomCreateStep = _a.setRoomCreateStep, exports.setRoomDeliveryRegion = _a.setRoomDeliveryRegion, exports.setRoomImage = _a.setRoomImage, exports.setRoomTitle = _a.setRoomTitle, exports.setIsFeeFree = _a.setIsFeeFree, exports.setStartDate = _a.setStartDate, exports.setEndDate = _a.setEndDate, exports.setDeliveryStartDate = _a.setDeliveryStartDate, exports.addRoomTag = _a.addRoomTag, exports.deleteRoomTag = _a.deleteRoomTag, exports.setProductImage = _a.setProductImage, exports.invalidateFreeFormData = _a.invalidateFreeFormData, exports.setProductInfo = _a.setProductInfo, exports.setDeliveryType = _a.setDeliveryType, exports.modifyFixed = _a.modifyFixed, exports.modifyAdditional = _a.modifyAdditional, exports.modifyConditional = _a.modifyConditional, exports.addDifferentials = _a.addDifferentials, exports.deleteDifferentials = _a.deleteDifferentials, exports.modifyDifferentials = _a.modifyDifferentials, exports.setDiffDeliveryInfo = _a.setDiffDeliveryInfo, exports.addCustom = _a.addCustom, exports.deleteCustom = _a.deleteCustom, exports.modifyCustom = _a.modifyCustom, exports.setNeedDeliveryChangeWarning = _a.setNeedDeliveryChangeWarning, exports.setCustomDeliveryInfo = _a.setCustomDeliveryInfo, exports.switchCustomDelivery = _a.switchCustomDelivery, exports.setContents = _a.setContents, exports.setRefundPolicy = _a.setRefundPolicy, exports.setKeepingRefundPolicy = _a.setKeepingRefundPolicy, exports.setPayType = _a.setPayType, exports.setSnsType = _a.setSnsType, exports.setIsRefundAccount = _a.setIsRefundAccount, exports.setSecondPaid = _a.setSecondPaid, exports.setSecondCustom = _a.setSecondCustom, exports.setAdditionalQuestions = _a.setAdditionalQuestions, exports.setIsSecret = _a.setIsSecret, exports.setSecretPassword = _a.setSecretPassword, exports.setSecretHint = _a.setSecretHint, exports.setPublicType = _a.setPublicType, exports.setIsMarketingConsent = _a.setIsMarketingConsent, exports.setTransfer = _a.setTransfer, exports.setIsOrderActive = _a.setIsOrderActive, exports.setIsNewRoomOpening = _a.setIsNewRoomOpening, exports.setRoomCategory = _a.setRoomCategory, exports.addAdditionQuestion = _a.addAdditionQuestion, exports.deleteAdditionQuestion = _a.deleteAdditionQuestion, exports.modifyAdditionQuestion = _a.modifyAdditionQuestion, exports.modifyAdditionImageCheck = _a.modifyAdditionImageCheck, exports.modifyAdditionRequiredCheck = _a.modifyAdditionRequiredCheck, exports.setRegularSales = _a.setRegularSales, exports.setIsTicket = _a.setIsTicket, exports.setOpenPromiseEditModal = _a.setOpenPromiseEditModal;
exports.roomCreateStore = (0, store_1.default)(roomCreateSlice.reducer);
